import {createSelector} from 'reselect'
import {State} from 'lib/store'
import {EnumState} from './reducer'

const selectFeature = (state: State): EnumState => state.enums

export const getEnums = (name: string) => createSelector(selectFeature, state => state[name])
